import React from 'react';
import { Heart, Award, Users, TrendingUp } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  user: Users,
  award: Award,
  heart: Heart,
  'trending-up': TrendingUp
};

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="heading-1">Your Guide to Transformation</h2>
            <p className="body-large">
              With over a decade of experience in holistic healing and personal transformation, 
              I&apos;ve dedicated my life to helping others break through limitations and step into 
              their highest potential.
            </p>
            <p className="body-medium">
              As a certified NLP Practitioner, Reiki Master, and Akashic Records reader, 
              I combine ancient wisdom with modern techniques to facilitate profound healing 
              and lasting change. Each session is a sacred space where you&apos;re fully supported 
              in your journey toward wholeness.
            </p>
            <p className="body-medium">
              My approach is intuitive, compassionate, and results-oriented. Whether you&apos;re 
              seeking clarity, healing, or transformation, I&apos;m here to guide you home to yourself.
            </p>
          </div>

          <div className="benefits-grid">
            {benefits.map((benefit) => {
              const IconComponent = iconMap[benefit.icon];
              return (
                <div key={benefit.id} className="benefit-card">
                  <div className="benefit-icon">
                    <IconComponent size={24} />
                  </div>
                  <h3 className="benefit-title">{benefit.title}</h3>
                  <p className="benefit-description">{benefit.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
